import { render } from "./UserSelectShop.vue?vue&type=template&id=c8c97af4&scoped=true"
import script from "./UserSelectShop.vue?vue&type=script&lang=js"
export * from "./UserSelectShop.vue?vue&type=script&lang=js"

import "./UserSelectShop.vue?vue&type=style&index=0&id=c8c97af4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c97af4"]])

export default __exports__